export const SET_SELECTED_QUANTITY = 'SET_SELECTED_QUANTITY';
